// extracted by mini-css-extract-plugin
module.exports = {"blockClock":"Timer_blockClock__cqWBs"};